import { parse } from 'querystring';
import { getIn } from 'seamless-immutable';
import React, { ReactNode } from 'react';
import { getCurrentSku } from '@catalogo/core-sku';
import { useRouteMatch, useLocation } from 'react-router-dom';
import config from '@catalogo/core-configuration/config/out/config.server.json';
import { useApolloClient } from '@apollo/client';
import { getProductPage } from '../queries/product-page.graphql';
import { MatchType } from '../types';

export const withProductCache = (Component: React.FC) => (props: { children: ReactNode }) => {
  const client = useApolloClient();
  const location = useLocation();
  const queryString = parse(location?.search?.replace('?', ''));
  const match = useRouteMatch('/produto/:id') as MatchType;
  const productId = match?.params?.id;
  const path = `/produto/${productId}`;
  const sellerId = queryString?.sellerId || '';
  const offerId = queryString?.offerId || '';
  const hasOfferId = !!offerId;

  const data = client.readQuery({
    query: getProductPage,
    variables: {
      productId,
      sellerId,
      path,
      segmented: false,
      brandCardId: config.brandCardId,
      offerId,
      hasOfferId,
      hasProductServices: config?.brand === 'acom',
    },
  });

  const currentSku = getCurrentSku(data, queryString);
  const offer = getIn(currentSku, ['offers', 'result', '0']);
  const componentProps = {
    productCache: {
      product: data?.product,
      currentSku,
      offer,
      page: data?.page,
    },
  };

  return <Component {...componentProps} {...props} />;
};
